<template>
  <section class="repair">
    <div class="container">
      <ServicesRepairItem
          v-for="item in repairList"
          v-bind:item = "item"
      />
    </div>
  </section>
</template>

<script>
import ServicesRepairItem from "@/components/ServicesRepairItem";
import {mapGetters} from "vuex";
export default {
  name: 'ServicesRepair',
  components: {
    ServicesRepairItem
  },
  methods: {},
  computed: {
    ...mapGetters (['repairList'])
  },
  mounted() {
  }
}
</script>

<style scoped lang='scss'>
.repair {
  padding: 15px 0 45px 0;
  @media (max-width: 997.98px) {
    padding: 0 0 20px 0;
  }
}
</style>
